import React from "react";
import {Typography, useTheme} from "@mui/material";
import {DataGrid} from "@mui/x-data-grid";
import {formatCurrency, formatPercent} from "../../utils/formatters";

export const NegativeMarginAlertTable = ({data, loading}) => {
    const theme = useTheme();
    const dims = theme.dimensions;

    const common = {sortable: true, disableColumnMenu: true, headerClassName: 'table-header'};
    const colDefs = [
        {...common, type: 'text', width: 160, headerAlign: 'left', field: 'sales_order_number', headerName: 'Sales Order Number'},
        {...common, type: 'number', width: 130, headerAlign: 'right', field: 'gross_revenue', headerName: 'Gross Revenue', valueFormatter: v => formatCurrency(v)},
        {...common, type: 'number', width: 140, headerAlign: 'right', field: 'discount_amount', headerName: 'Discount Amount', valueFormatter: v => formatCurrency(v)},
        {...common, type: 'number', width: 110, headerAlign: 'right', field: 'discount_percent', headerName: 'Discount %', valueFormatter: v => formatPercent(v, 2)},
        {...common, type: 'number', width: 120, headerAlign: 'right', field: 'net_revenue', headerName: 'Net Revenue', valueFormatter: v => formatCurrency(v)},
        {...common, type: 'number', width: 120, headerAlign: 'right', field: 'vcogs', headerName: 'VCOGS', valueFormatter: v => formatCurrency(v)},
        {...common, type: 'number', width: 130, headerAlign: 'right', field: 'variable_margin', headerName: 'Variable Margin', valueFormatter: v => formatCurrency(v)},
        {...common, type: 'number', width: 140, headerAlign: 'right', field: 'variable_margin_percent', headerName: 'Variable Margin %', valueFormatter: v => formatPercent(v, 2)},
        {...common, type: 'number', width: 110, headerAlign: 'right', field: 'freight_costs', headerName: 'Freight', valueFormatter: v => formatCurrency(v)},
        {...common, type: 'number', width: 150, headerAlign: 'right', field: 'commission_costs_percent_avg', headerName: 'Commission Avg %', valueFormatter: v => formatPercent(v, 2)},
        {...common, type: 'number', width: 120, headerAlign: 'right', field: 'commission_costs', headerName: 'Commission', valueFormatter: v => formatCurrency(v)},
        {...common, type: 'number', width: 150, headerAlign: 'right', field: 'pocket_price_margin', headerName: 'Pocket Margin', valueFormatter: v => formatCurrency(v)},
        {...common, type: 'number', width: 140, headerAlign: 'right', field: 'pocket_price_margin_percent', headerName: 'Pocket Margin %', valueFormatter: v => formatPercent(v, 2)}
    ];

    const determineRowClass = (params) => {
        return params.indexRelativeToCurrentPage % 2 === 1 ? 'table-row-odd' : 'table-row-even';
    };

    return (
        <div style={{width: dims.contentWidth}}>
            <Typography variant="h6" color="inherit" style={{marginBottom: 10}}>Sales Order(s) With Negative Margin</Typography>
            <DataGrid columns={colDefs} rows={data} loading={loading}
                      columnHeaderHeight={30} rowHeight={30} autoHeight
                      getRowClassName={params => determineRowClass(params)}
                      initialState={{
                          pagination: {paginationModel: {pageSize: 10}},
                          sorting: {sortModel: [{field: 'pocket_price_margin', sort: 'asc'}]}
                      }}
                      pageSizeOptions={[10, 25]}
                      disableRowSelectionOnClick disableMultipleRowSelection disableColumnResize/>
        </div>
    );
};
